module.exports = __webpack_public_path__ + "img/16.06ec4c20.jpg";